import { API } from "./../../../api/config";

export const fetchConsignedOrderAPI = (params) => {
    return API.get("/pmbpartner/consigned-order", { params })
              .then((res) => res);
};

export const getConsignedOrderByIdAPI = (consignedOrderSk) => {
  return API.get(`/pmbpartner/consigned-order/${consignedOrderSk}`)
            .then((res) => res);
};

export const getProductOptionsAPI = () => {
    return API.get("/pmbpartner/products")
              .then((res) => res);
};

export const getPartnersAPI = () => {
  return API.get("/pmbpartner/partners")
            .then(res => res);
}

export const getDistributorOptionsAPI = (params) => {
  return API.get("/pmbpartner/distributor-options", { params })
            .then((res) => res);
};

export const getAllOrderStatusesAPI = () => {
  return API.get("/pmbpartner/get-status-options")
            .then(res => res)
}

export const getAllPaymentTermsAPI = () => {
  return API.get("/pmbpartner/get-all-payment-term")
            .then(res => res);
}

export const approveOrRejectOrderAPI = (payload) => {
  return API.post(`/pmbpartner/consigned-order/${payload?.orderId}/${payload?.action}`, { comment: payload?.comment })
            .then(res => res);
}

export const sendOrderToPuzzleAPI = () => {
  return API.post("/pmbpartner/send-orders-to-puzzle")
            .then(res => res);
}

export const getOrdersPuzzleAPI = () => {
  return API.get("/pmbpartner/get-orders-puzzle")
            .then(res => res);
}

export const saveConsignedOrderAPI = (payload) => {
  return API.post(`/pmbpartner/consigned-order/${payload.orderId}`, payload?.body)
            .then(res => res);
}

export const updateOrderStatusAPI = (payload) => {
  return API.patch(`/pmbpartner/consigned-order/update-status/${payload.orderId}`, payload?.body)
            .then(res => res);
}

export const bulkStatusUpdateAPI = (payload) => {
  return API.patch(`/pmbpartner/consigned-order/bulk-status-update`, payload)
            .then(res => res);
}